import { PointsLevel, PointsRank } from '../types/points.js';
export default class PointsService {
    sdk;
    constructor(sdk) {
        this.sdk = sdk;
    }
    async getPoints(account) {
        const params = new URLSearchParams({
            user: account.toLowerCase(),
        });
        const url = `${this.sdk.context.apiUrl}/exp/points?${params.toString()}`;
        const response = await fetch(url);
        const res = await response.json();
        return res.total
            ? res
            : {
                total: 0,
                placement: 0,
                user: { address: '', level: PointsLevel.NPC_I, rank: PointsRank.NPC },
            };
    }
}
//# sourceMappingURL=points.js.map